import { IClientConfigs } from '~/shared';
import { createSlice } from '../wrappers';

export enum StageTypes {
	Main = 'main',
	RegionSelection = 'regionSelection',
}

export type NumberPlatesRegion =
	IClientConfigs['vehicleNumberPlates']['regions'][number];

interface VehicleRegistrationSlice {
	region: NumberPlatesRegion | null;
	stage: StageTypes;
}

const initialState: VehicleRegistrationSlice = {
	region: null,
	stage: StageTypes.Main,
};

const vehicleRegistrationSlice = createSlice({
	name: 'vehicleRegistration',
	initialState,
	reducers: {
		setRegion: (state, action) => {
			state.region = action.payload;
		},
		setStage: (state, action) => {
			state.stage = action.payload;
		},
	},
});

export const { setRegion, setStage } = vehicleRegistrationSlice.actions;

export default vehicleRegistrationSlice.reducer;
